import SelectTag from "./select_tag";

export default class SelectTagWithCollapsibleContent extends SelectTag {
  constructor(node) {
    super(node);
    this.element = node;

    this.inputs = this.dropdownElement.querySelectorAll("input[type='radio']");

    this.inputs.forEach((radioInput) => {
      let wrapperElement = radioInput.closest(".js-collapsible-content-wrapper");

      if (wrapperElement === null) {
        wrapperElement = document.body;
      }

      radioInput.addEventListener("change", (e) => {
        wrapperElement.classList.toggle("show-collapsible-content", e.target.classList.contains("js-toggle-collapsible-content"));
      });
    });
  }

  handleSelectTagClick(e) {
    if (this.element.dataset.hasModal === "true") {
      const { target } = e;

      const selectValue = target.querySelector(".js-select-value");
      const input = target.querySelector("input");

      if (selectValue) {
        this.selectedValue.innerHTML = selectValue.innerHTML;
        this.inputElement.value = input.value;
        this.inputElement.dispatchEvent(new Event("change"));

        this.inputs.forEach((input) => {
          input.checked = false;
        });

        input.checked = true;
        input.dispatchEvent(new Event("change"));
        selectValue.click();
      }

      this.toggleDropdown();
    } else {
      super.handleSelectTagClick(e);
    }
  }
}
